import { ComponentType, ReactNode } from "react";
import { ReactComponent as AdminConsoleIcon } from "../../assets/admin-console.svg";
import { ReactComponent as AssignmentUploadsIcon } from "../../assets/assignment-uploads-icon.svg";
import { ReactComponent as AssignmentManagementIcon } from "../../assets/assignment-management.svg";
import { ReactComponent as CertificateIcon } from "../../assets/certificate.svg";
import { ReactComponent as HomeIcon } from "../../assets/home.svg";
import { ReactComponent as ModuleAssignmentsIcon } from "../../assets/moduleAssignments.svg";
import { ReactComponent as PortalConfigurationIcon } from "../../assets/portal-configuration-icon.svg";
import { ReactComponent as PortalDesignIcon } from "../../assets/portalDesign.svg";
import { ReactComponent as PortalPagesIcon } from "../../assets/portalPages.svg";
import { ReactComponent as PortalTextIcon } from "../../assets/portalText.svg";
import { ReactComponent as PortalSettingsIcon } from "../../assets/settings.svg";
import { ReactComponent as UserAttributesIcon } from "../../assets/user-bulk.svg";
import { ReactComponent as UserManagementIcon } from "../../assets/user-management.svg";
import { ReactComponent as UsersIcon } from "../../assets/users.svg";
import { ReactComponent as EmailManagementIcon } from "../../assets/email-management.svg";
import { ReactComponent as EmailTemplatesIcon } from "../../assets/email-templates.svg";
import { ReactComponent as AnalyticIcon } from "../../assets/analytics.svg";
import { ReactComponent as ReportDashboardIcon } from "../../assets/dashboard.svg";
import { ReactComponent as ViewReportsIcon } from "../../assets/description.svg";
import { ReactComponent as GroupCardsIcon } from "../../assets/view_module.svg";
import { ReactComponent as FileExchangeIcon } from "../../assets/file-exchange.svg";
import { ReactComponent as FindInPageIcon } from "../../assets/findInPage.svg";
import { ReactComponent as BulkUserActions } from "../../assets/user-bulk.svg";

export interface SubMenuItem {
  label: string;
  icon: string | ReactNode | ComponentType<React.SVGAttributes<SVGSVGElement>>;
  route: string;
  tooltip: string;
}

export interface MainMenuItem {
  label: string;
  icon: string | ReactNode | ComponentType<React.SVGAttributes<SVGSVGElement>>;
  route?: string;
  tooltip: string;
  subMenus?: SubMenuItem[];
  onClick?: (e: React.MouseEvent) => void;
}

export const portalDesignNav = (
  portalUid: string | undefined,
): MainMenuItem[] => [
  {
    label: "Portal configuration",
    icon: PortalConfigurationIcon,
    tooltip: "Portal configuration",
    subMenus: [
      {
        label: "Portal settings",
        icon: PortalSettingsIcon,
        route: `/portal-configuration/${portalUid}/portal-settings`,
        tooltip: "Portal settings",
      },
      {
        label: "Portal design",
        icon: PortalDesignIcon,
        route: `/portal-configuration/${portalUid}/portal-design`,
        tooltip: "Portal design",
      },
      {
        label: "Portal translation",
        icon: PortalTextIcon,
        route: `/portal-configuration/${portalUid}/portal-translation`,
        tooltip: "Portal translation",
      },
      {
        label: "Portal pages",
        icon: PortalPagesIcon,
        route: `/portal-configuration/${portalUid}/portal-pages`,
        tooltip: "Portal pages",
      },
      {
        label: "User attributes",
        icon: UserAttributesIcon,
        route: `/portal-configuration/${portalUid}/user-attributes`,
        tooltip: "User attributes",
      },
      {
        label: "Group cards",
        icon: GroupCardsIcon,
        route: `/portal-configuration/${portalUid}/group-cards`,
        tooltip: "Group cards",
      },
    ],
  },
  {
    label: "Analytics",
    icon: AnalyticIcon,
    tooltip: "Analytics",
    subMenus: [
      {
        label: "Dashboard",
        icon: ReportDashboardIcon,
        route: `/portal-configuration/${portalUid}/dashboard`,
        tooltip: "Report dashboard",
      },
      {
        label: "Reports",
        icon: ViewReportsIcon,
        route: `/portal-configuration/${portalUid}/reports`,
        tooltip: "Reports",
      },
    ],
  },
  {
    label: "Assignments",
    icon: AssignmentManagementIcon,
    tooltip: "Assignments",
    subMenus: [
      {
        label: "Search",
        icon: ModuleAssignmentsIcon,
        route: `/portal-configuration/${portalUid}/assignment-search`,
        tooltip: "Search",
      },
      {
        label: "Uploads",
        icon: AssignmentUploadsIcon,
        route: `/portal-configuration/${portalUid}/assignment-uploads`,
        tooltip: "Uploads",
      },
    ],
  },
  {
    label: "User management",
    icon: UserManagementIcon,
    tooltip: "User management",
    subMenus: [
      {
        label: "Search",
        icon: UsersIcon,
        route: `/portal-configuration/${portalUid}/users`,
        tooltip: "Search",
      },
      {
        label: "Bulk user actions",
        icon: BulkUserActions,
        route: `/portal-configuration/${portalUid}/bulk-user-actions`,
        tooltip: "Bulk user actions",
      },
    ],
  },
  {
    label: "Email management",
    icon: EmailManagementIcon,
    tooltip: "Email management",
    subMenus: [
      {
        label: "Email templates",
        icon: EmailTemplatesIcon,
        route: `/portal-configuration/${portalUid}/email-templates`,
        tooltip: "Email templates",
      },
    ],
  },
  {
    label: "File Hub",
    icon: FileExchangeIcon,
    tooltip: "File Hub",
    subMenus: [
      {
        label: "Search",
        icon: FindInPageIcon,
        route: `/portal-configuration/${portalUid}/file-hub`,
        tooltip: "Search",
      },
    ],
  },
  {
    label: "Home",
    icon: HomeIcon,
    route: "/home",
    tooltip: "Home",
  },
];

export const defaultNav: MainMenuItem[] = [
  { label: "Home", icon: HomeIcon, route: "/home", tooltip: "Home" },
  {
    label: "Certificates",
    icon: CertificateIcon,
    route: "/certificates",
    tooltip: "Certificates",
  },
  {
    label: "Admin console",
    icon: AdminConsoleIcon,
    route: "/portal-configuration",
    tooltip: "Admin console",
  },
];
